import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery } from '@percent/partner-dashboard/common/hooks'
import { Flex, Loader, Text } from '@percent/lemonade'
import { Achievement } from './Achievement/Achievement'
import styles from './EmployeeAchievements.module.scss'

export type EmployeeAchievementsProps = Readonly<{
  accountId: string
}>

export function EmployeeAchievements({ accountId }: { accountId: string }) {
  const { workplaceGivingService } = useServices()

  const [{ data, isLoading, errorMessage }] = useQuery(workplaceGivingService.getAccountAchievements, { accountId })

  if (isLoading) {
    return <Loader />
  }

  if (!data || errorMessage) {
    return <Text>{errorMessage}</Text>
  }

  return (
    <Flex direction="column" className={styles.container}>
      {data.rulesAndAchievements.map(achievement => (
        <Achievement key={achievement.achievement.id} achievement={achievement} />
      ))}
    </Flex>
  )
}
